export interface CatalogTerm {
    id: ID;
    products?: ID[];
    type: CatalogTermType;
    name: string;
    caption?: string;
    value?: number;
}

export enum CatalogTermType {
    PRODUCTS = "products",
    TRANSIT_DURATION = "transit_duration",
    ARRIVAL_SPAN = "arrival_span",
    ARRIVAL_WINDOW = "arrival_window",
    MINIMUM_AMOUNT = "minimum_amount",
    EXPIRY = "expiry",
    USAGE_LIMIT = "usage_limit",
}
